
import React from "react";
import Loading from "../../Loading.js";
import MediaQuery from 'react-responsive';
import * as actions from '../../../store/actions/index';
import { connect } from "react-redux";
import ShareDialog from "../../ShareDialog.js";
import ReplayHand from "../../HandReplayer/ReplayHand.js";
import SpinReportCardContent from './SpinReportCardContent';
import { domain, secretKey, facebook_appId, mppl_redirect_uri, baseUrl, partyBrands } from "../../../common/config.js";
import queryString from "query-string";
import moment from "moment";
import { Redirect } from "react-router";
import { apiService } from '../../../common/apiCallService.js'
import { saveActivity,updateOnBoard } from "../../../common/commonService";
import OnBoard from '../../MygameOnBoard/OnBoard';
import * as htmlToImage from 'html-to-image';
import { DispatcherFunction } from 'mygame-components';
import i18next from 'i18next'
import {
    ReportCardFilter,
    ReportHeading,
    ReportSummary,
    ReportSummaryMessage,
    ShareToSocialMedia,
    NewShareToSocialMedia,
    ShareReportCardModal
} from "mygame-components";
import './spin.css';
import { getColor, getDarkTextColor, getHoverColor, getTextColor } from "../../../common/ThemeService.js";
let _ = require("lodash"),
    fullVersion = 0;
class Spin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: 'Spin Report Card',
            accountName: props.match.params.accountName,
            reportSettingsOpen: false,
            shareDialogOpen: false,
            shareTrack: {},
            screenshot: '',
            access: JSON.parse(localStorage.getItem('userRole')),
            loading: false,
            redirectUrl: '/',
            loginRedirect: false,
            shareIcon: '//' + domain + '/images/shareIcon.jpg',
            redirect: false,
            openHandRep: false,
            shareId: '',
            shareLink: '',
            openSocialMediaDialog: false,
            banner_url: '',
            stars: '',
            copiedLink: "",
            handDtls:{},
            isOnBoard: localStorage.getItem('mygame_onboarded') === 'N' ? 1 : 0,
            openReportCardShareModal:false,
            selectedSummeryRange:[],
            analysisArray:[],
            replModal:null,
            brand:localStorage.getItem('loggedInType')
        }
        const { hitRange, hitType, hitLevel, fromDate, toDate, shift = 'Select' } = queryString.parse(this.props.location.search);
        let { gameType, accountName } = props.match.params,
            plyerReportSetting = (this.props.reportCardSetting.filter(plyReportSetting => plyReportSetting.gameType === gameType)[0])

        plyerReportSetting = plyerReportSetting.hitRange === 'Select' || this.props.history.action === 'POP'
            ? { ...plyerReportSetting, ...{ gameType, fromDate, toDate, accountName, shift, hitRange, hitType, hitLevel } }
            : this.props.multiGamePlayerReports.filter(game => game.gameType === gameType)[0]
        this.props.getOnLoadReportCardDtls(plyerReportSetting)

    }

    componentWillReceiveProps = async (nextProps) => {
        if (nextProps.playerReports.hands < 100 && this.props.playerReports.hands != nextProps.playerReports.hands) {
            this.setState({ redirect: true })
        }
        fullVersion = await this.getDeviceVersion()
    }

    disableOnBoard = async () => {
        this.setState({ loading: true, isOnBoard: 0 })
        await updateOnBoard()
        this.setState({ loading: false })
    }

    handReplayerOpen = (handReply) => {
      saveActivity({
        hit_page: 'ReportCard',
        hit_type: 'ReportCardGameReplay',
        hit_attribute1: handReply.gameNo,
        hit_attribute2: this.props.match.params.gameType,
      })
      handReply.partitionDate = handReply.time;
      if(window.messageToNative || (window.external && window.external.NativeDispatch)){
        DispatcherFunction("app:menu=3814&name=MYGAME_REPLAYER",{
            "MYGAME_REPLAYER_URL":'https://' + window.location.hostname +
            `/PopUpHandReplayer/${this.props.gameType}/${handReply.gameNo}/${this.state.accountName}/${handReply.fullDateTime? handReply.fullDateTime: handReply.time}` ,
            "location":"yes",
            "height":"720",
            "width":"1000",
            "scrollbars":"yes",
            "status":"yes"
      })}
        else{
        this.setState({
            gameNo: handReply.gameNo,
            partitionDate: handReply.partitionDate,
            handDtls:handReply,
            openHandRep: true
        });
        this.forceUpdate();
    }
    };
    getDeviceVersion = async () => {
        try {
            // console.log("navigator.appVersion-----------------------")
            // console.log(navigator.appVersion)
            if (navigator.appVersion.indexOf("Mac") >= 0) {
              if (navigator.appVersion.indexOf("Mobile") >= 0) {
                let osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
                fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2] + osVersion[3]);
                if (fullVersion > 12.10) {
                  fullVersion = 13
                } else {
                  fullVersion = 12
                }
              } else {
                let osVersion = /OS X (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
                // console.log("osVersion",osVersion)
                if(osVersion){
                  fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2]);
                  if (fullVersion > 10.13) {
                    fullVersion = 13
                  } else {
                    fullVersion = 12
                  }
                } else {
                  fullVersion = 12
                }
              }
            } else {
              fullVersion = 13;
            }
            return fullVersion
        } catch (error) {
            console.log(error);
            throw new Error(error)
        }
    }
    saveSettings = (values) => {
        try {
            let defaultReportSettings = {
                playerChangeFilter:true,
                accountName: this.props.match.params.accountName,
                level: 'All Level',
                shift: "Select", hitType: '3 max',
                hitRange: localStorage.getItem('userRole') && JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') != -1 ? 'This Year' : 'Select',
            },
                isReportSettingChange = _.isEqual(this.props.formData.reportCardSettingFilter.initial, this.props.formData.reportCardSettingFilter.values)
            if (!isReportSettingChange) {
                if (values.range == 'Select') delete values.range
                if (Object.keys(values).length > 0) {
                    if (values.level) defaultReportSettings.hitLevel = values.level
                    if (values.type) defaultReportSettings.hitType = values.type

                    if (values.range) {
                        defaultReportSettings.hitRange = values.range
                        if (values.range == 'Today') {
                            defaultReportSettings.fromDate = moment().startOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
                            defaultReportSettings.toDate = moment().endOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
                        }
                        else {
                            defaultReportSettings.rangeChange = true
                        }
                    }
                    let settings = {
                        ...(this.props.reportCardSetting.filter(reportFilter => reportFilter.gameType === this.props.gameType)[0]),
                        ...defaultReportSettings
                    }
                    if (values.range == 'Today') {
                        let SB = "All";
                        let BB = "All";
                        if (settings.hitLevel && settings.hitLevel !== "All Level") {
                            [SB, BB] = settings.hitLevel.split("/");
                        }
                        let gameDateInfo = moment().format('DD/MM/YYYY');
                        this.props.getSingleReportCardsDetails({
                            ...settings,
                            key: `${gameDateInfo}:${localStorage.getItem("accountname")}:${settings.gameType}:${settings.hitType}:${SB}:${BB}`
                        })
                    } else {
                        this.props.getSingleReportCardsDetails(settings)
                    }
                }
            }
            this.setState({ reportSettingsOpen: false })
        } catch (error) {
            console.log(error)
        }
    }
    getShareId = (data) => new Promise((resolve, reject) => {
        let { type, banner_url, title, description, hit_attribute1, hit_attribute2, hit_attribute3, hit_attribute4, gameType, level, stars } = data
        const {summaryRange} =this.props.playerReports;
        let selectedSummeryRange = [];
        let analysis = [];
        summaryRange.map((item)=>{
            item.enable = true;
            delete item.expandFlag;
            analysis.push(item.category.trim());
            selectedSummeryRange.push(item);
        })
        this.setState({
            openReportCardShareModal:true,
            shareObj: data,
            analysisArray:analysis,
            selectedSummeryRange:selectedSummeryRange
        })
        
        // apiService(
        //     baseUrl + '/shareLinkMetadata/save',
        //     { type, banner_url, title, description, hit_attribute1, hit_attribute2, hit_attribute3, hit_attribute4 },
        //     ({ _id: shareId }) => {
        //         saveActivity({
        //             hit_page: 'ReportCard',
        //             hit_type: 'ReportCardShareModalOpened',
        //             hit_attribute1: shareId,
        //             hit_attribute2: gameType,
        //             hit_attribute3: level,
        //             hit_attribute4: stars,
        //             hit_attribute6: localStorage.getItem("accountName"),
        //         })
        //         this.setState({
        //             shareId,
        //             shareLink: `https://${domain}/share/reportcard?id=${shareId}`,
        //             openSocialMediaDialog: true,
        //             stars: stars,
        //             banner_url: banner_url
        //         })
        //         this.forceUpdate()
        //         resolve()
        //     },
        //     reject
        // )
    })

    getSocialShareId = (reportCardObject) => new Promise((resolve, reject) =>{
        const { shareObj } = this.state;
        // var node = document.getElementById('testShareReportId');

        //             htmlToImage.toPng(node)
        //             .then(function (dataUrl) {
        //                 var img = new Image();
        //                 img.src = dataUrl;
        //                 console.log("img--------->",img.src);
        //                 document.body.appendChild(img);
        //             })
        //             .catch(function (error) {
        //                 console.error('oops, something went wrong!', error);
        //             });
        let { type, banner_url, title, description, hit_attribute1, hit_attribute2, hit_attribute3, hit_attribute4, gameType, level, stars } = shareObj;
         apiService(
            baseUrl + '/shareLinkMetadata/save',
            { type, banner_url, title, description, attribute1:hit_attribute1, attribute2:hit_attribute2,
                attribute3:hit_attribute3, attribute4:hit_attribute4, attribute5:this.state.brand, reportCardObject:reportCardObject},
            ({ _id: shareId }) => {
                saveActivity({
                    hit_page: 'ReportCard',
                    hit_type: 'ReportCardShareModalOpened',
                    hit_attribute1: shareId,
                    hit_attribute2: gameType,
                    hit_attribute3: level,
                    hit_attribute4: stars,
                    hit_attribute5: this.state.brand,
                    reportCardObject:reportCardObject
                })
                this.setState({
                    shareId,
                    shareLink: `https://${domain}/share/reportcard?id=${shareId}`,
                    openSocialMediaDialog: true,
                    stars: stars,
                    banner_url: banner_url
                })
                this.forceUpdate()
                resolve()
            },
            reject
        )
    })

    onNextClick = async () => {
        const {playerReports} = this.props
        const { selectedSummeryRange, analysisArray } = this.state;
        let stats = analysisArray.join();
        saveActivity({
            hit_page: 'ReportCard',
            hit_type: 'ReportCardStats',
            hit_attribute1: this.props.gameType,
            hit_attribute2: stats,
        })
      //  const result = selectedSummeryRange.filter((item) => item.enable);
        const playerStatsResult =  playerReports.playerStats.filter((item)=>analysisArray.includes(item.category) )
        let reportCardObject = {
           summeryRange:selectedSummeryRange,
           playerStats: playerStatsResult,
           hands:playerReports.hands,
           summaryInfo:playerReports.summaryInfo[0],
           luckfactor:playerReports.luckfactor,
           accountName:this.state.accountName,
           playerName:localStorage.getItem("first_name") || localStorage.getItem("alias"),
           lastReportUpdatedDate:new Date(),
           star:playerReports.star,
           gameType:this.props.gameType
       }
        await this.getSocialShareId(reportCardObject);
        this.setState({
            openSocialMediaDialog:true
        })
        
    }

    shareOnFacebook = async () => {
        const { shareId, shareLink } = this.state;
        //let dataUrl = await this.loadImage();
        saveActivity({
            hit_page: 'ReportCard',
            hit_type: 'ReportCardLinkShared',
            hit_attribute1: shareId,
            hit_attribute2: this.props.playerReports.gameType,
            hit_attribute3: this.props.playerReports.summaryInfo[0].medal,
            hit_attribute4: this.props.playerReports.star,
            hit_attribute5: 'facebook',
        })
        if (window.messageToNative || (window.external && window.external.NativeDispatch)) {
            window.open(
                `https://www.facebook.com/dialog/share?app_id=${facebook_appId}&display=popup&href=${encodeURIComponent(shareLink + `&source=facebook`)}`,
                '_blank'
            )
        } else {
            window.open(
                `https://www.facebook.com/dialog/share?app_id=${facebook_appId}&display=popup&href=${encodeURIComponent(shareLink + `&source=facebook`)}`,
                '_blank',
                'width=600,height=400'
            )
        }
        this.shareModal_close();
    }

    shareOnTwitter = () => {
        const { shareId, shareLink } = this.state;
        saveActivity({
            hit_page: 'ReportCard',
            hit_type: 'ReportCardLinkShared',
            hit_attribute1: shareId,
            hit_attribute2: this.props.playerReports.gameType,
            hit_attribute3: this.props.playerReports.summaryInfo[0].medal,
            hit_attribute4: this.props.playerReports.star,
            hit_attribute5: 'twitter',
        })
        this.shareModal_close();
        if (window.messageToNative || (window.external && window.external.NativeDispatch)) {
            window.open(
                `https://twitter.com/share?url=${encodeURIComponent(shareLink + '&source=twitter')}&&text=check your score on&&via=partypoker`,
                '_blank'
            )
        } else {
            window.open(
                `https://twitter.com/share?url=${encodeURIComponent(shareLink + '&source=twitter')}&&text=check your score on&&via=partypoker`,
                '_blank',
                'width=600,height=400'
            )
        }
    }
    loadImage = () => new Promise((resolve, reject) => {
        var node = document.getElementById('viewShareReportCardId');
        htmlToImage.toPng(node)
        .then(function (dataUrl) {
            var img = new Image();
            img.src = dataUrl;
            resolve(img.src);
        })
        .catch(function (error) {
            console.error('oops, something went wrong!', error);
        });
    })
    handleToggleSwith = (item) => {
        const {selectedSummeryRange, analysisArray} = this.state;
        let index = selectedSummeryRange.findIndex((data)=>item.category === data.category);
        if (index !== -1) {
            let analysisIndex = analysisArray.findIndex((data)=>data === item.category);
            if(analysisIndex !== -1) {
                analysisArray.splice(analysisIndex,1);
            }
            selectedSummeryRange[index].enable = !selectedSummeryRange[index].enable;
            this.setState({
                selectedSummeryRange,
                analysisArray
            })
        }
    }
    shareModal_close = () => this.setState({ openSocialMediaDialog: false, copiedLink: "", openReportCardShareModal:false })
    handleClose  = () => this.setState( {openReportCardShareModal:false });

    render() {
        const themeColor = getColor();
        const themeTextColor = getTextColor();
        const themeDarkTextColor = getDarkTextColor();
        const themeHoverColor = getHoverColor();
        const queryParams = queryString.parse(this.props.location.search),
            { playerReports, reportCardSetting, medalsDetails, gameType, starsDetails } = this.props,
            showShareModal = this.state.openSocialMediaDialog ? 'displayBlock' : 'displayNone';
        this.props.setHeaderTitle(this.state.title);
        let { fromDate, toDate, hitLevel, hitRange, hitType, accountName, shift } = this.props.reportCardSetting.filter(plyReportSetting => plyReportSetting.gameType === gameType)[0]
        // if(this.state.openSocialMediaDialog){
        //     return <div>
        //     <ViewSharedReportCard shareId={this.state.shareId}/>
        //     <NewShareToSocialMedia
        //                         open ={this.state.openSocialMediaDialog}
        //                         handleClose = {this.handleClose}
        //                             stars={this.state.stars}
        //                             banner_url={this.state.banner_url}
        //                             showShareModal={showShareModal}
        //                             shareModal_close={this.shareModal_close}
        //                             shareOnTwitter={this.shareOnTwitter}
        //                             shareOnFacebook={this.shareOnFacebook}
        //                             shareLink={this.state.shareLink}
        //                             copiedLink={this.state.copiedLink}
        //                             setCopiedLink={(shareLink) => {
        //                                 this.setState({ copiedLink: shareLink })
        //                             }}
        //                         />
        // </div>
        // }
        return (
            <div>
                <style>
                    {`.shareLevel, .levelInfo {\
                            background-color: ${themeColor} !important;\ 
                            border-color: ${themeColor} !important;\
                            color: ${themeTextColor} !important;\
                        }\
                    `}
                    {`.closeButtonhoverEffect:hover {\
                            background-color: ${themeHoverColor} !important;\ 
                        }\
                    `}
                    {`.shareLevel:hover, .levelInfo:hover {\
                            background-color: ${themeHoverColor} !important;\
                            color: ${themeDarkTextColor} !important;\
                        }\
                    `}
                    {`.toggle-switch-label {\
                        border-color: ${themeColor};\
                    }\
                    .toggle-switch-switch {\
                        background-color: ${themeColor};\
                    }\
                    `}
                </style>
                <NewShareToSocialMedia
                    i18next={i18next}
                    open ={this.state.openSocialMediaDialog}
                    handleClose = {this.handleClose}
                        stars={this.state.stars}
                        banner_url={this.state.banner_url}
                        showShareModal={showShareModal}
                        shareModal_close={this.shareModal_close}
                        shareOnTwitter={this.shareOnTwitter}
                        shareOnFacebook={this.shareOnFacebook}
                        shareLink={this.state.shareLink}
                        copiedLink={this.state.copiedLink}
                        setCopiedLink={(shareLink) => {
                            saveActivity({
                                            hit_page: 'ReportCard',
                                            hit_type: 'ReportCardLinkShared',
                                            hit_attribute2: this.props.playerReports.gameType,
                                            hit_attribute3: this.props.playerReports.summaryInfo[0].medal,
                                            hit_attribute4: this.props.playerReports.star,
                                            hit_attribute5: 'copylink'
                                        })
                            this.setState({ copiedLink: shareLink })
                        }}
                    />
                {(this.props.loading || this.state.loading) && <Loading />}
                {this.state.isOnBoard ==1 && JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') != -1  && <OnBoard  disableOnBoard={this.disableOnBoard}/>}
                {this.state.redirect ?
                    (queryParams.source && queryParams.source === 'mygamelive'
                        ? <Redirect to={'/SkillLevel?logintype=player&source=mygamelive'} />
                        : <Redirect to={`/SkillLevel?logintype=player&accountName=${this.props.match.params.accountName}`} />)
                    : null}
                {
                    Object.keys(playerReports).length > 0 &&
                    <div>
                        {this.state.reportSettingsOpen && (
                            <ReportCardFilter
                                i18next={i18next}
                                access={this.state.access}
                                levels={playerReports.playerLevels}
                                open={this.state.reportSettingsOpen}
                                saveSettings={() => this.saveSettings}
                                closeFilter={() => this.setState({ reportSettingsOpen: false })}
                                medalUrl={playerReports.summaryInfo[0].medal && ('//' + domain + '/images/Medals/' + (partyBrands.includes(this.state.brand) ? 'PartyPoker/spin/' : 'spin/') + playerReports.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "") + '/' + playerReports.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "") + '_' + playerReports.star + '.png')} saveSettings={() => this.saveSettings}
                            />
                        )}
                        <ShareDialog
                            i18next={i18next}
                            contentStyle={{ width: 300, maxWidth: "none" }}
                            title="Share hand replayer"
                            modal={true}
                            open={this.state.shareDialogOpen}
                            type={"image"}
                            message={"https://www.partypoker.com"}
                            image={this.state.screenshot}
                            trackData={this.state.shareTrack}
                            onRequestClose={this.onShareDiaogClose}
                        />
                          {!this.state.openSocialMediaDialog && this.state.openReportCardShareModal && <ShareReportCardModal 
                          i18next={i18next}
                        open ={this.state.openReportCardShareModal}
                        handleClose = {this.handleClose}
                        data ={this.state.shareObj}
                        medalUrl={playerReports.summaryInfo[0].medal && ('//' + domain + '/images/Medals/' + (partyBrands.includes(this.state.brand) ? ('PartyPoker/' + playerReports.gameType) : playerReports.gameType) + '/' + playerReports.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "") + '/' + playerReports.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "") + '_' + playerReports.star + '.png')}
                        analysisArray={this.state.selectedSummeryRange}
                        handleToggleSwith={this.handleToggleSwith}
                        level={playerReports.summaryInfo[0].medal}
                        score={playerReports.summaryInfo[0].points}
                        noOfHands={playerReports.hands}
                        onNextClick={this.onNextClick}
                        />}
                        <div style={{ backgroundColor: 'white', boxShadow: '0 2px 6px 2px rgba(0,0,0,0.09)' }}>
                            <div className="container" style={{ paddingTop: "25.7px" }} >
                                {/* <SpinReportHeading />
                                <SpinRepoSummary /> */}
                                {playerReports.summaryInfo.length > 0 && (
                                    <ReportHeading
                                    i18next={i18next}
                                        gameType={'Spin'}
                                        playerReports={playerReports}
                                        onSettingsClick={_ => this.setState({ reportSettingsOpen: true })}
                                        reportCardSetting={reportCardSetting.filter(reopFilter => reopFilter.gameType === "spin")[0]}
                                    />
                                )}

                                {/* {this.state.openSocialMediaDialog &&
                                    <ShareToSocialMedia
                                        stars={this.state.stars}
                                        banner_url={this.state.banner_url}
                                        showShareModal={showShareModal}
                                        shareModal_close={this.shareModal_close}
                                        shareOnTwitter={this.shareOnTwitter}
                                        shareOnFacebook={this.shareOnFacebook}
                                        shareLink={this.state.shareLink}
                                        copiedLink={this.state.copiedLink}
                                        setCopiedLink={(shareLink) => {
                                            this.setState({ copiedLink: shareLink })
                                        }}
                                    />
                                } */}
                              
                                <MediaQuery maxWidth={991} >
                                    <div className="bottom"></div>
                                </MediaQuery>
                                <div className="grid report-stats">
                                    {medalsDetails &&
                                        starsDetails &&
                                        playerReports.summaryInfo[0].medal && (
                                            <ReportSummary
                                                i18next={i18next}
                                                domain={domain}
                                                stars={playerReports.star}
                                                starsDetails={starsDetails}
                                                medalsDetails={medalsDetails}
                                                noOfHands={playerReports.hands}
                                                gameType={playerReports.gameType}
                                                getShareId={(data) => this.getShareId(data)}
                                                level={playerReports.summaryInfo[0].medal}
                                                score={playerReports.summaryInfo[0].points}
                                                medalUrl={'//' + domain + '/images/Medals/' + (partyBrands.includes(this.state.brand) ? 'PartyPoker/spin/' : 'spin/') + playerReports.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "") + '/' + playerReports.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "") + '_' + playerReports.star + '.png'}
                                            />
                                        )}

                                    <div className="report_summary_wrapper">
                                        <ReportSummaryMessage  i18next={i18next} summary={playerReports.summaryInfo[0].comment} gameType={gameType} />
                                        <MediaQuery maxWidth={991} >
                                            <div className="bottom"></div>
                                        </MediaQuery>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container" >
                            <div className="spin-stats-block">
                                <div className="my-game-analysis">
                                {i18next.t("lable.myGameAnalysis")}{['Select', 'Today'].indexOf(hitRange) === -1 && <span className='updatedDateNote'> (Note: Last updated on: {playerReports.lastReportUpdatedDate ? moment(playerReports.lastReportUpdatedDate).format('DD-MM-YYYY') : "N/A"})</span>}
                                </div>
                                <MediaQuery maxWidth={760}>
                                    <div className="spin-repo-bottom-border" style={{ marginBottom: '6px', padding: '0px' }}></div>
                                </MediaQuery>
                                {playerReports.hands >= 100 &&
                                <div>
                                    <SpinReportCardContent
                                        i18next={i18next}
                                        handsAnalysed={playerReports.hands}
                                        summaryInfo={playerReports.summaryInfo[0]}
                                        playerStatistics={playerReports.playerStats}
                                        summaryRange={playerReports.summaryRange}
                                        errorSummary={playerReports.biggestErrorSummary}
                                        biggestErrorBySituations={playerReports.biggestErrorBySituations}
                                        accountName={this.state.accountName}
                                        isErrorTable={false}
                                        handReplayerOpen={this.handReplayerOpen}
                                    />
                                </div>}
                            </div>
                        </div>
                        <div className="container" style={{ marginBottom: "32px" }} >
                            <div className="spin-stats-block">
                                <div className="my-game-analysis">{i18next.t("lable.myBiggestErrors")}</div>
                                <MediaQuery maxWidth={760}>
                                    <div className="spin-repo-bottom-border" style={{ marginBottom: '6px', padding: '0px' }}></div>
                                </MediaQuery>
                                {playerReports.hands >= 100 &&
                                <div>
                                    <SpinReportCardContent
                                        i18next={i18next}
                                        handsAnalysed={playerReports.hands}
                                        summaryInfo={playerReports.summaryInfo[0]}
                                        playerStatistics={playerReports.playerStats}
                                        summaryRange={playerReports.biggestErrorSummary}
                                        accountName={this.state.accountName}
                                        isErrorTable={true}
                                        handReplayerOpen={this.handReplayerOpen}
                                    />
                                </div>}
                            </div>
                        </div>

                    </div>
                }
                {this.state.openHandRep ? (
                    <div
                        style={{
                            top: 0,
                            left: 0,
                            zIndex: 20000,
                            width: "100%",
                            height: "100%",
                            overflow: "auto",
                            position: "fixed",
                            backgroundColor: "#2c2c34"
                        }}
                    >
                        {fullVersion && parseFloat(fullVersion) < 13 ? (
                            <HandReplayer
                            // i18next={i18next}
                                replayerScreen={"desktop"}
                                gameTypeForTitle={"Spin"}
                                handDtls={this.state.handDtls}
                                onClose={() => this.setState({ openHandRep: false })}
                                loginStatus={true}
                                toDate={toDate}
                                gameType={gameType}
                                fromDate={fromDate}
                                gameNo={this.state.gameNo}
                                accountName={playerReports.accountName}
                                playerAlias={playerReports.playerName}
                                partitionDate={this.state.partitionDate}
                            />
                        ) : (
                                <ReplayHand
                                    // i18next={i18next}
                                    replayerScreen={"desktop"}
                                    loginStatus={true}
                                    handDtls={this.state.handDtls}
                                    toDate={toDate}
                                    gameType={"Spin"}
                                    fromDate={fromDate}
                                    gameNo={this.state.gameNo}
                                    gameTypeForTitle={gameType}
                                    partitionDate={this.state.partitionDate}
                                    accountName={this.props.playerReports.accountName}
                                    playerAlias={this.props.playerReports.playerName}
                                    onClose={() => this.setState({ openHandRep: false })}
                                />
                            )}
                    </div>
                ) : (
                        <div></div>
                    )}

            </div >
        );
    }
}
const mapStateToProps = state => {
    return {
        loading: state.commonReducer.loading,
        potsLoading: state.commonReducer.isPromotional,
        gameType: state.multipleReportCards.gameType,
        reportCardSetting: state.multipleReportCards.reportCardSetting,
        missions: state.multipleReportCards.playerReports.missions,
        playerReports: state.multipleReportCards.playerReports,
        starsDetails: state.multipleReportCards.starsDetails,
        medalsDetails: state.multipleReportCards.medalsDetails,
        formData: state.form,
        promotionalContent: state.multipleReportCards.promotionalContent,
        multiGamePlayerReports: state.multipleReportCards.multiGamePlayerReports
    };
};


const mapDispatchToProps = dispatch => {
    return {
        setHeaderTitle: (newTitle) => dispatch(actions.setHeaderTitle(newTitle)),
        getOnLoadReportCardDtls: (playerReports) => dispatch(actions.getOnLoadReportCardDtls(playerReports)),
        getSingleReportCardsDetails: (reportCardSetting) => dispatch(actions.getSingleReportCardsDetails(reportCardSetting))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Spin);


/** WEBPACK FOOTER **
 ** ./src/components/ReportCard/Spin/Spin.js
 **/